import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";

import PageHeading from "../../../../components/common/PageHeading";
import FormAction from "../../../../components/common/FormAction";

import dayjs from "dayjs";
import { toast } from "react-hot-toast";

const NewTenant = () => {
  const [isUseCompanyName, setisUseCompanyName] = useState(false);
  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: 1, type: "", phoneNumber: "", details: "" },
  ]);
  const [emails, setEmails] = useState([{ id: 1, email: "" }]);
  const [addresses, setAddresses] = useState([
    {
      id: 1,
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    },
  ]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const currentDate = dayjs();
  const navigate = useNavigate();

  const { id } = useParams();

  //Phone numbers adding

  const handleInputChange = (value, name, id) => {
    const updatedPhoneNumbers = phoneNumbers.map((phoneNumber) => {
      if (phoneNumber.id === id) {
        return { ...phoneNumber, [name]: value };
      }
      return phoneNumber;
    });
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const addPhoneNumber = () => {
    const newPhoneNumber = {
      id: phoneNumbers.length + 1,
      type: "",
      phoneNumber: "",
      additionalDetails: "",
    };
    setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
  };

  const removePhoneNumber = (id) => {
    const updatedPhoneNumbers = phoneNumbers.filter(
      (phoneNumber) => phoneNumber.id !== id
    );
    setPhoneNumbers(updatedPhoneNumbers);
  };

  //Emails adding

  const handleEmailChange = (value, name, id) => {
    const updatedEmails = emails.map((email) => {
      if (email.id === id) {
        return { ...email, [name]: value };
      }
      return email;
    });
    setEmails(updatedEmails);
  };

  const addEmail = () => {
    const newEmail = {
      id: emails.length + 1,
      email: "",
    };
    setEmails([...emails, newEmail]);
  };

  const removeEmail = (id) => {
    const updatedEmails = emails.filter((email) => email.id !== id);
    setEmails(updatedEmails);
  };

  //Address adding

  const handleOnInputChange = (value, name, id) => {
    const updatedAddresses = addresses.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setAddresses(updatedAddresses);
  };

  const addAddress = () => {
    const newAddress = {
      id: addresses.length + 1,
      addressOne: "",
      addressTwo: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
    };
    setAddresses([...addresses, newAddress]);
  };

  const removeAddress = (id) => {
    const updatedAddresses = addresses.filter((item) => item.id !== id);
    setAddresses(updatedAddresses);
  };

  const handleFormSubmit = async (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });

    const filteredPhoneNumbers = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const filteredEmails = emails.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const filteredAddresses = addresses.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const tenant = {
      profileInfo: {
        salutation: values.salutation,
        firstName: values.firstName,
        middleName: values.middleName,
        lastName: values.lastName,
        companyName: values.companyName,
        companyNameAsDisplay: values.companyNameAsDisplay,
        ref_tenant_id: id,
      },
      contact: {
        phoneNumbers: filteredPhoneNumbers,
        emails: filteredEmails,
        addresses: filteredAddresses,
      },
      tenantStatus: {
        tenantType: values.tenantType,
        moveInDate: values.moveInDate.format("YYYY-MM-DD"),
        moveOutDate: values.moveOutDate
          ? values.moveOutDate.format("YYYY-MM-DD")
          : "",
        noticeDate: values.noticeDate
          ? values.noticeDate.format("YYYY-MM-DD")
          : "",
      },
      screening: {
        dateOfBirth: values.dateOfBirth
          ? values.dateOfBirth.format("YYYY-MM-DD")
          : "",
        driverLicense: values.driverLicense,
        state: values.state,
        ssn: values.ssn,
        creditReportDate: values.creditReportDate
          ? values.creditReportDate.format("YYYY-MM-DD")
          : "",
        CreditScore: values.CreditScore,
      },
      emergencyContact: {
        name: values.name,
        address: values.address,
        phoneNumber: values.phoneNumber,
        emailAddress: values.emailAddress,
        relationship: values.relationship,
      },
    };

    const tenantRef = collection(db, "companies", companyName, "tenants");

    try {
      await addDoc(tenantRef, tenant);
      toast.success("Tenant created successfully");
    } catch (err) {
      alert(err);
      console.log(err);
    }
  };

  const handleSubmitionFailed = (err) => {
    console.log(err);
  };

  const onCancel = () => {
    navigate("/people/tenants");
  };

  const initialValues = {
    moveInDate: currentDate,
  };
  return (
    <div>
      <PageHeading heading="New Tenant" />
      <Form
        name="basic"
        labelCol={{
          span: 6,
        }}
        autoComplete="off"
        colon={false}
        onFinish={handleFormSubmit}
        onFinishFailed={handleSubmitionFailed}
        initialValues={initialValues}
      >
        <Card>
          <Form.Item
            label="Salutation"
            name="salutation"
            placeholder="Select..."
          >
            <Select
              options={[
                { value: "Dr" },
                { value: "Mr" },
                { value: "Mr. & Mrs." },
                { value: "Mrs." },
                { value: "Ms." },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="First Name"
            required={isUseCompanyName ? false : true}
            name="firstName"
            rules={[{ required: isUseCompanyName ? false : true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Middle Initial" name="middleName">
            <Input />
          </Form.Item>
          <Form.Item
            label="Last Name"
            required={isUseCompanyName ? false : true}
            name="lastName"
            rules={[{ required: isUseCompanyName ? false : true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Company Name"
            required={isUseCompanyName ? true : false}
            name="companyName"
            rules={[{ required: isUseCompanyName ? true : false }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label=" "
            name="companyNameAsDisplay"
            valuePropName="checked"
          >
            <Checkbox onChange={() => setisUseCompanyName(!isUseCompanyName)}>
              Use Company Name as display name
            </Checkbox>
          </Form.Item>
        </Card>
        <Card title="Contact" style={{ marginTop: "20px" }}>
          <h4>Phone Numbers</h4>
          <ul>
            {phoneNumbers.map((item) => (
              <li key={item.id}>
                <Row gutter={16}>
                  <Col span={15} offset={2}>
                    <Form.Item label=" ">
                      <Input
                        placeholder="Phone Number"
                        value={item.phoneNumber}
                        onChange={(e) =>
                          handleInputChange(
                            e.target.value,
                            "phoneNumber",
                            item.id
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item value={item.type}>
                      <Select
                        options={[
                          {
                            value: "Fax",
                          },
                          {
                            value: "Home",
                          },
                          {
                            value: "Mobile",
                          },
                          {
                            value: "Office",
                          },
                        ]}
                        style={{ width: "100%" }}
                        onChange={(value) =>
                          handleInputChange(value, "type", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={23}>
                    <Form.Item label=" ">
                      <Input
                        placeholder="Additional Details"
                        value={item.details}
                        onChange={(e) =>
                          handleInputChange(e.target.value, "details", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    {phoneNumbers.length > 1 ? (
                      <Form.Item>
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            removePhoneNumber(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      </Form.Item>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </li>
            ))}
            <Row>
              <Col span={23}>
                <Form.Item label=" ">
                  <Button
                    className="addPropertyGroupButton"
                    type="primary"
                    onClick={() => addPhoneNumber()}
                    icon={<i className="fa-solid fa-circle-plus"></i>}
                    style={{ width: "100%" }}
                  >
                    Add Another Phone Number
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </ul>
          <h4>Emails</h4>
          <ul>
            {emails.map((item) => (
              <li key={item.id}>
                <Row>
                  <Col span={23}>
                    <Form.Item
                      label=" "
                      name={`email${item.id}`}
                      rules={[
                        {
                          type: "email",
                          message: "Please enter a valid email address",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Email"
                        value={item.email}
                        onChange={(e) =>
                          handleEmailChange(e.target.value, "email", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    {emails.length > 1 ? (
                      <Form.Item>
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            removeEmail(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      </Form.Item>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </li>
            ))}
            <Row>
              <Col span={23}>
                <Form.Item label=" ">
                  <Button
                    className="addPropertyGroupButton"
                    type="primary"
                    onClick={() => addEmail()}
                    style={{ width: "100%" }}
                    icon={<i className="fa-solid fa-circle-plus"></i>}
                  >
                    Add Another Email
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </ul>
          <h4>Addresses</h4>
          <ul>
            {addresses.map((item) => (
              <li key={item.id}>
                <Row gutter={16} key={item.id}>
                  <Col span={23}>
                    <Form.Item label=" ">
                      <Input
                        placeholder="Address 1"
                        value={item.addressOne}
                        onChange={(e) =>
                          handleOnInputChange(
                            e.target.value,
                            "addressOne",
                            item.id
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={23}>
                    <Form.Item label=" ">
                      <Input
                        placeholder="Address 2"
                        value={item.addressTwo}
                        onChange={(e) =>
                          handleOnInputChange(
                            e.target.value,
                            "addressTwo",
                            item.id
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={11} offset={3}>
                    <Form.Item label=" ">
                      <Input
                        placeholder="City"
                        value={item.city}
                        onChange={(e) =>
                          handleOnInputChange(e.target.value, "city", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item>
                      <Select
                        placeholder="State"
                        options={[
                          { value: "AA" },
                          { value: "AE" },
                          { value: "AK" },
                        ]}
                        style={{ width: "100%" }}
                        value={item.state}
                        onChange={(e) =>
                          handleOnInputChange(e, "state", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item>
                      <Input
                        placeholder="Zip"
                        value={item.zipCode}
                        onChange={(e) =>
                          handleOnInputChange(
                            e.target.value,
                            "zipCode",
                            item.id
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={23}>
                    <Form.Item label=" ">
                      <Select
                        allowClear
                        showArrow
                        placeholder="Country"
                        options={[
                          { value: "United State" },
                          { value: "Canada" },
                          { value: "United Kingdom" },
                        ]}
                        style={{ width: "100%" }}
                        value={item.country}
                        onChange={(e) =>
                          handleOnInputChange(e, "country", item.id)
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={1}>
                    {addresses.length > 1 ? (
                      <Form.Item>
                        <Button
                          className="roundSmallButton"
                          onClick={() => {
                            removeAddress(item.id);
                          }}
                          type="primary"
                          shape="circle"
                          icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                          size={"small"}
                        />
                      </Form.Item>
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </li>
            ))}
            <Row>
              <Col span={23}>
                <Form.Item label=" ">
                  <Button
                    className="addPropertyGroupButton"
                    type="primary"
                    onClick={() => addAddress()}
                    style={{ width: "100%" }}
                    icon={<i className="fa-solid fa-circle-plus"></i>}
                  >
                    Add Another Address
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </ul>
        </Card>
        <Card title="Tenant Status" style={{ marginTop: "20px" }}>
          <Form.Item label="Type" name="tenantType" placeholder="Select...">
            <Select
              options={[
                { value: "Financially Responsible" },
                { value: "Other Occupant" },
                { value: "Co-signer" },
              ]}
            />
          </Form.Item>
          <Form.Item
            label="Move In"
            required
            rules={[{ required: true }]}
            name="moveInDate"
          >
            <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Move Out" name="moveOutDate">
            <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Notice" name="noticeDate">
            <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
          </Form.Item>
        </Card>
        <Card title="Screening" style={{ marginTop: "20px" }}>
          <Form.Item label="Date Of Birth" name="dateOfBirth">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Drivers License" name="driverLicense">
            <Input />
          </Form.Item>
          <Form.Item label="State" name="state">
            <Select
              options={[{ value: "AA" }, { value: "AE" }, { value: "AK" }]}
              style={{ width: "100%" }}
            />
          </Form.Item>
          <Form.Item label="SSN" name="ssn">
            <Input />
          </Form.Item>
          <Form.Item label="Credit Report Date" name="creditReportDate">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Credit Score" name="CreditScore">
            <Input />
          </Form.Item>
        </Card>
        <Card title="Emergency Contact" style={{ marginTop: "20px" }}>
          <Form.Item label="Name" name="name">
            <Input />
          </Form.Item>
          <Form.Item label="Address" name="address">
            <Input />
          </Form.Item>
          <Form.Item label="Phone Number" name="phoneNumber">
            <Input />
          </Form.Item>
          <Form.Item
            label="Email Address"
            name="emailAddress"
            rules={[
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="Relationship" name="relationship">
            <Input />
          </Form.Item>
        </Card>
        <br />
        <FormAction submit="submit" cancel={onCancel} />
      </Form>
      <div className="RightSidebar"></div>
    </div>
  );
};

export default NewTenant;
